import { RankingState } from '../states/ranking.state'
import { Action, createReducer, on } from '@ngrx/store'
import {
  purgeRanking,
  setRanking,
  setRankingContext,
  setRankingLoader,
  setRankingMatchDay,
  setRankingSourceMetric
} from '../actions/ranking.actions'

const initialState: RankingState = {
  ranking: undefined,
  sourceMetric: undefined,
  metricToRank: undefined,
  metricContext: undefined,
  displayMode: undefined,
  matchDay: undefined,
  loading: undefined
}

const reducer = createReducer(
  initialState,
  on(setRanking, (state, { ranking }): RankingState => ({ ...state, ranking })),
  on(
    setRankingContext,
    (state, { metricToRank, metricContext, displayMode }): RankingState => ({
      ...state,
      metricToRank,
      metricContext,
      displayMode
    })
  ),
  on(setRankingMatchDay, (state, { matchDay }): RankingState => ({ ...state, matchDay })),
  on(setRankingSourceMetric, (state, { sourceMetric }): RankingState => ({ ...state, sourceMetric })),
  on(setRankingLoader, (state, { loading }): RankingState => ({ ...state, loading })),
  on(purgeRanking, (): RankingState => ({ ...initialState }))
)

export const rankingsReducer = (state: RankingState | undefined, action: Action): RankingState => reducer(state, action)
